/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const CloseBtn = styled.button.attrs({
  type: 'button'
})`
  
  position: absolute;
  margin-left: -4rem;
  float: right;
  margin-top: 20px;
  // z-index: 30;

  & > .svg-close {
    display: block;
    padding: 2px;
    fill: white;
    width: 30px;
    height: 30px;
    background-color: #474748;
    border-radius: 15px;
    transition: opacity 0.2s ease-out;
    opacity: 0.8;
    backface-visibility: hidden;
  }

  &:hover > .svg-close {
    opacity: 1;
  }
`;
